/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { shieldLockPuzzleOffblack } from "../assets/shield-lock-puzzle-offblack";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconShieldLockPuzzleOffblack = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={shieldLockPuzzleOffblack.svg} />
);

IllustrativeIconShieldLockPuzzleOffblack.displayName = "IllustrativeIconShieldLockPuzzleOffblack";
